import React, { useContext, useMemo } from "react";
import Header from "components/Header";
import style from "./index.module.scss";
import MHeader from "components/MHeader";
import { useHistory } from "react-router-dom";
import useDeviceType from "Utils/useDeviceType";
import { CourseContext } from "../../Store";
import { Breadcrumb } from "antd";

interface CourseLayoutProps {
    children: React.ReactNode;
}

export default function TeamLayout({ children }: CourseLayoutProps) {
    const history = useHistory();
    const { isPC } = useDeviceType();

    const { basename } = useContext(CourseContext);
    function isMatch(path: string) {
        return history.location.pathname.indexOf(path) !== -1;
    }

    const title = useMemo(() => {
        if (isMatch("/teams")) {
            return "我的小组";
        }
        if (isMatch("/teamDetail")) {
            return "小组作业";
        }
        return "";
    }, [history.location.pathname]);

    return (
        <div>
            {isPC && <Header />}
            {!isPC && <MHeader title={title} goBack={history.goBack} />}
            <div className={style.container}>
                {isPC && (
                    <Breadcrumb separator=">" style={{ marginBottom: 10 }}>
                        <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
                        <Breadcrumb.Item href={`${basename}/teams`}>
                            课程内容
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>{title}</Breadcrumb.Item>
                    </Breadcrumb>
                )}
                <div className={style.body}>
                    <div className={style.main}>{children}</div>
                </div>
            </div>
        </div>
    );
}
